import React from 'react'
import { Select } from 'antd'
import { ProfileOutlined } from '@ant-design/icons'
// import { connect } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import { selectCompany } from '../../redux/companySelect/actions'
import { getCompanyById } from '../../utils'

// @connect(({ accounts, companySelect }) => ({ accounts, companySelect }))
const Company = () => {
  const dispatch = useDispatch()
  const handleChange = value => {
    dispatch(selectCompany(value))
  }

  const { data: companies } = useSelector(s => s.accounts)
  const { selected } = useSelector(s => s.companySelect)
  console.log('sselected', selected)
  const selectedCompany = getCompanyById(companies, selected)
  const singleCompany = companies.length === 1

  const select = (
    <Select defaultValue={selected} value={selected} style={{ width: 160 }} disabled={companies.length === 0} onChange={handleChange} className="ml-2">
      {companies.length === 0 && (
        <Select.Option value={-1}>
          <FormattedMessage id="accounts.select_company" />
        </Select.Option>
      )}
      {companies.map(c => {
        return (
          <Select.Option key={c.id} value={c.id} company={c}>
            {c.name}
          </Select.Option>
        )
      })}
    </Select>
  )

  const text = <span className="ml-2">{selectedCompany ? selectedCompany.name : '...'}</span>

  return (
    <>
      <ProfileOutlined style={{ fontSize: 16 }} />
      {singleCompany && text}
      {!singleCompany && select}
    </>
  )
}

export default Company
